<template>
    <Base>
        <v-card-title class="text-center d-block">
            <span class="t-color-brand-medium-base">Recuperar senha</span>
        </v-card-title>
        <v-card-text>
            <form
                :action="route('password.update')"
                id="formResetPass"
                method="post"
            >
                <cp-csrf-token/>
                <input type="hidden" :value="token" name="token" />
                <v-text-field
                    label="E-mail"
                    v-model="email"
                    name="email"
                    outlined
                    dense
                    required
                ></v-text-field>
                <v-text-field
                    label="Nova Senha"
                    name="password"
                    outlined
                    dense
                    required
                    :append-icon="showPass ? '$eye' : '$eyeOff'"
                    :type="showPass ? 'text' : 'password'"
                    @click:append="showPass = !showPass"
                ></v-text-field>
                <v-text-field
                    label="Confirmar senha"
                    name="password_confirmation"
                    outlined
                    dense
                    required
                    :append-icon="showPassConfirm ? '$eye' : '$eyeOff'"
                    :type="showPassConfirm ? 'text' : 'password'"
                    @click:append="showPassConfirm = !showPassConfirm"
                ></v-text-field>

                <div class="d-flex justify-space-between">
                    <cp-button
                        color="secondary"
                        type="button"
                        :disabled="saving"
                        :loading="saving"
                        :href="route('login')"
                    >
                        Login
                    </cp-button>
                    <cp-button
                        color="primary"
                        type="submit"
                        :disabled="saving"
                        :loading="saving"
                        @click="submit"
                        class="ml-5"
                    >
                        Salvar nova senha
                    </cp-button>
                </div>
            </form>
        </v-card-text>
    </Base>
</template>

<script>
import Base from '@components/common/Base'

export default {
    data: () => ({
        saving: false,
        token: '',
        email: '',
        showPass: false,
        showPassConfirm: false,
    }),

    metaInfo: () => ({
        title: 'Recuperar senha'
    }),

    created() {
        this.init();
    },

    components: {
        Base
    },

    methods: {
        init() {
            let params = this.getUrlParams()

            this.token = params.token
            this.email = params.email
        },

        submit() {
            this.saving = true;
            document.querySelector('#formResetPass').submit();
        },
    }
}
</script>